// extracted by mini-css-extract-plugin
module.exports = {"icon":"R4o7rSjc3q02+83kPsecAA=="};